import TemplateView from "../../TemplateView";
import {formatFML} from "../../util/UserNameFormat";
import messageResource from "../../messageResource"

export default class CopyAssignmentsFromButton extends TemplateView {
    constructor() {
        super()

        this.state = {
            selectedUser: null,
        }

        this.onStatePropertyChanged('selectedUser', (user) => {
            const username = user ? formatFML(user.firstName, user.lastName, user.middleName) : ""
            const buttonTitle = user ? username : messageResource.getMessage("assign_to.tasks.users_selector.empty_selection_text")
            this.$userButton.text(buttonTitle);
        })
    }

    templateHtml() {
        return "<div class='buttonWrapper'>" +
               "    <div class='user ellipsis'/>" +
               "</div>"
    }

    afterRender() {
        this.$userButton = this.find('.user')
        this.renderInitialState()
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/CopyAssignmentsFromButton.js